import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-person-operation-panel-jica",
  templateUrl: "./operation-panel-jica.component.html",
  styleUrls: ["./operation-panel-jica.component.css"],
})
export class PersonOperationPanelJicaComponent {
  // 親コンポーネントからの入力
  @Input() selectedCount: number = 0;
  @Input() questionCategory: any[] = [];
  @Input() differencialDownload: boolean = false;

  // 親コンポーネントへのイベント通知
  @Output() onMail = new EventEmitter<void>();
  @Output() onDownload = new EventEmitter<any[]>();
  @Output() onBulkDownload = new EventEmitter<any[]>();
  @Output() onSaikenDownload = new EventEmitter<any[]>();
  @Output() onShowList = new EventEmitter<void>();
  @Output() differencialDownloadChange = new EventEmitter<boolean>();

  // チェックボックスの状態変更を通知
  onDiffChange(val: boolean) {
    this.differencialDownloadChange.emit(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/operation-panel/jica/operation-panel-jica.component.ts